import Drawer from "@material-ui/core/Drawer";
import React, { useEffect, useRef, useState } from "react";
import { navigate } from "../../routes";
import { useAuth } from "../Auth/useAuth";
import { useCart } from "../Carts/useCart";
import FSLoader from "../Loaders/FSLoader";
import useTranslations from "../Translations/useTranslations";
import ArticleGeneriqueCard from "./ArticleGeneriqueCard";
import "./ArticlesGeneriques.css";
import CriteresList from "./CriteresList";
import { useArticlesGeneriques } from "./useArticlesGeneriques";

function ArticlesGeneriques({
  codfag,
  search_criteria,
  selected_criteres,
  selectCritere,
  resetCritere,
  articleOpen,
  gen_articles,
}) {
  const trl = useTranslations();
  const [loading, isLoading] = useState(true);
  const [loadingFilters, isLoadingFilters] = useState(true);
  const [articles_generiques, articlesGeneriquesMethods] =
    useArticlesGeneriques();

  const [critereModalOpen, setCritereModalOpen] = useState(false);
  const [loadingItem, setLoadingItem] = useState(null);

  const [auth] = useAuth();
  const [{ current_cart }, { getCartData }] = useCart(
    auth.user?.client_profile?.id,
  );
  useEffect(() => {
    if (!current_cart) {
      navigate.goBack();
    }
  }, [current_cart]);
  const prevCodfagRef = useRef(codfag);

  const isMounted = useRef(true);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const selectGen = (gen) => {
    if (isMounted.current) setLoadingItem(gen.CODGEN);
    articlesGeneriquesMethods.getItem(
      gen.CODGEN,
      { codcli: current_cart.client.CODCLI },
      (err, _gen) => {
        if (!isMounted.current) return;
        gen_articles(_gen);
        setLoadingItem(null);
        articleOpen();
      },
    );
  };

  useEffect(() => {
    if (!current_cart) return;
    const codfagChanged = prevCodfagRef.current !== codfag;
    prevCodfagRef.current = codfag;

    if (isMounted.current) isLoadingFilters(true);
    articlesGeneriquesMethods.getFilters({ codfag }, () => {
      if (!isMounted.current) return;
      isLoadingFilters(false);
      if (codfagChanged) {
        resetCritere();
      }
    });

    if (isMounted.current) isLoading(true);
    if (!search_criteria) {
      articlesGeneriquesMethods.getCollection(
        { codfag, codcli: current_cart.client?.CODCLI },
        () => isMounted.current && isLoading(false),
      );
    } else {
      articlesGeneriquesMethods.getCollection(
        { codfag, search_criteria, codcli: current_cart.client?.CODCLI },
        () => isMounted.current && isLoading(false),
      );
    }
  }, [codfag, search_criteria]);

  if (loading) return <FSLoader />;

  function renderFiltersButton() {
    return (
      <React.Fragment>
        <button
          id="open-filters"
          className="filter_button"
          onClick={() => setCritereModalOpen(true)}
        />
      </React.Fragment>
    );
  }

  function renderProducts() {
    if (!articlesGeneriquesMethods.has("filter_results")) return null;
    const filteredArticles = articles_generiques.filter_results.filter((it) => {
      if (!selected_criteres || Object.keys(selected_criteres).length === 0) {
        return true;
      }
      return Object.values(selected_criteres).every((critere) => {
        if (!critere) return true;
        const regexp = new RegExp(critere);
        return it.LISTE_CRITERES.match(regexp);
      });
    });

    const itemsInCartDef = (el) => {
      if (
        !current_cart ||
        !current_cart.products ||
        !current_cart.products[el]
      ) {
        return 0;
      }
      return current_cart.products[el].reduce((a, b) => a + b.qte_commande, 0);
    };
    if (filteredArticles.length === 0) {
      return (
        <React.Fragment>
          <div className="no_products_message text-center">
            <span>
              Désolé, nous ne trouvons aucun résultat pour votre recherche.
            </span>
            <span>
              Vérifiez l'orthographe ou utilisez un mot-clef différent.
            </span>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {filteredArticles.map((articleG, key) => (
          <ArticleGeneriqueCard
            key={key}
            articleG={articleG}
            showArticles={() => selectGen(articleG)}
            loading={loadingItem === articleG.CODGEN}
            itemsInCart={itemsInCartDef(
              trl.data.message("GEN", "CODGEN", articleG.CODGEN, "LIBGEN"),
            )}
            isPack={articleG.TYPGEN === "PACK"}
          />
        ))}
        {filteredArticles.length <= 3 &&
          filteredArticles.map(() => <div></div>)}
      </React.Fragment>
    );
  }

  function renderCriteresList() {
    if (!articlesGeneriquesMethods.has("criteres")) return null;
    return (
      <React.Fragment>
        <Drawer
          open={critereModalOpen}
          onClose={() => setCritereModalOpen(false)}
          anchor="right"
        >
          <CriteresList
            criteres={articles_generiques.criteres}
            selectedCriteres={selected_criteres}
            selectCritere={selectCritere}
            className="criteres_list_drawer"
          />
        </Drawer>
      </React.Fragment>
    );
  }
  //  base
  return (
    <React.Fragment>
      {renderFiltersButton()}
      <div className="articles_generiques--container">
        <div className="products_container mb-4">{renderProducts()}</div>
      </div>
      {renderCriteresList()}
    </React.Fragment>
  );
}

export default ArticlesGeneriques;
